"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_helmet_1 = require("react-helmet");
function Meta({ title, description }) {
    return (jsx_runtime_1.jsxs(react_helmet_1.Helmet, { children: [jsx_runtime_1.jsx("title", { children: title }, void 0),
            jsx_runtime_1.jsx("meta", { property: "og:type", content: "article" }, void 0),
            jsx_runtime_1.jsx("meta", { property: "og:title", content: title }, void 0),
            description && jsx_runtime_1.jsx("meta", { property: "og:description", content: description }, void 0),
            description && jsx_runtime_1.jsx("meta", { name: "description", content: description }, void 0)] }, void 0));
}
exports.default = Meta;
